module.exports = __webpack_public_path__ + "img/25_29.b256dc7c.png";